/*
 * @Description: 元件模块接口
 * @Date: 2022-04-12 09:55:04
 * @LastEditTime: 2023-05-17 17:16:23
 */
export default {
  // 属性模块
  addNewProperty: {
    url: "/tacos-cloud-console/v1/property/add",
    method: "put",
    desc: "新增属性"
  },
  getStandardProperty: {
    url: "/tacos-cloud-console/v1/property/standard/page",
    method: "post",
    desc: "获取标准属性列表"
  },
  getCustomProperty: {
    url: "/tacos-cloud-console/v1/property/custom/page",
    method: "post",
    desc: "获取自定义属性列表"
  },
  updateProperty: {
    url: "/tacos-cloud-console/v1/property/update",
    method: "put",
    desc: "更新属性"
  },
  // releasedProperty: {
  //   url: "/tacos-cloud-console/v1/property/released",
  //   method: "put",
  //   desc: "发布属性"
  // },
  getUnitList: {
    url: "/tacos-cloud-console/v1/baseData/list",
    method: "post",
    desc: "获取单位列表"
  },
  deleteProperty: {
    url: "/tacos-cloud-console/v1/property/remove-by-id",
    method: "delete",
    desc: "删除属性"
  },
  getFunByProp: {
    url: "/tacos-cloud-console/v1/function/getByPropertyId",
    method: "get",
    desc: "根据属性ID查询所属功能"
  },
  getPropById: {
    url: "/tacos-cloud-console/v1/property/getById",
    method: "get",
    desc: "根据属性ID查询属性详情"
  },
  getStandardPropById: {
    url: "/tacos-cloud-console/v1/property/standard/getById",
    method: "get",
    desc: "根据ID查询标准属性详情"
  },
  // 指令模块
  addNewCommand: {
    url: "/tacos-cloud-console/v1/command/add",
    method: "put",
    desc: "新增指令"
  },
  commandRevokeReleased: {
    url: "/tacos-cloud-console/v1/command/revoke-released",
    method: "put",
    desc: "指令版本撤销发布"
  },
  updateCommand: {
    url: "/tacos-cloud-console/v1/command/update",
    method: "put",
    desc: "编辑指令"
  },
  getCustomCommandList: {
    url: "/tacos-cloud-console/v1/command/custom/page",
    method: "post",
    desc: "获取自定义指令列表"
  },
  getStandardCommandList: {
    url: "/tacos-cloud-console/v1/command/standard/page",
    method: "post",
    desc: "获取标准指令列表"
  },
  getCommandById: {
    url: "/tacos-cloud-console/v1/command/getById",
    method: "get",
    desc: "根据指令ID查询指令详情"
  },
  getStandardCommandById: {
    url: "/tacos-cloud-console/v1/command/standard/getById",
    method: "get",
    desc: "根据指令ID查询指令详情"
  },
  releasedCommand: {
    url: "/tacos-cloud-console/v1/command/released",
    method: "put",
    desc: "发布指令"
  },
  deleteCommand: {
    url: "/tacos-cloud-console/v1/command/remove-by-id",
    method: "delete",
    desc: "删除指令"
  },
  getFunByCommand: {
    url: "/tacos-cloud-console/v1/function/getByCommandId",
    method: "get",
    desc: "根据指令ID查询所属功能"
  },
  getStandardFunctionByMember: {
    url: "/tacos-cloud-console/v1/function/standard/pageFunctionVerByMember",
    method: "post",
    desc: "元件所属标准功能版本分页查询"
  },
  getCustomFunctionByMember: {
    url: "/tacos-cloud-console/v1/function/custom/pageFunctionByMember",
    method: "post",
    desc: "元件所属自定义功能分页查询"
  },
  addNewEvent: {
    url: "/tacos-cloud-console/v1/event/add",
    method: "put",
    desc: "新增事件"
  },
  updateEvent: {
    url: "/tacos-cloud-console/v1/event/update",
    method: "put",
    desc: "编辑事件"
  },
  deleteEvent: {
    url: "/tacos-cloud-console/v1/event/remove-by-id",
    method: "delete",
    desc: "删除事件"
  },
  getCustomEventList: {
    url: "/tacos-cloud-console/v1/event/custom/page",
    method: "post",
    desc: "获取自定义事件列表"
  },
  getStandardEventList: {
    url: "/tacos-cloud-console/v1/event/standard/page",
    method: "post",
    desc: "获取标准事件"
  },
  getEventById: {
    url: "/tacos-cloud-console/v1/event/getById",
    method: "get",
    desc: "根据事件ID查询事件详情"
  },
  getStandardEventById: {
    url: "/tacos-cloud-console/v1/event/standard/getById",
    method: "get",
    desc: "根据事件ID查询事件详情"
  },
  releasedEvent: {
    url: "/tacos-cloud-console/v1/event/released",
    method: "put",
    desc: "发布事件"
  },
  getFunByEvent: {
    url: "/tacos-cloud-console/v1/function/getByEventId",
    method: "get",
    desc: "根据事件ID查询所属功能"
  },
  // 功能模块
  addNewFunc: {
    url: "/tacos-cloud-console/v1/function/add",
    method: "put",
    desc: "新增功能"
  },
  updateFunc: {
    url: "/tacos-cloud-console/v1/function/update",
    method: "put",
    desc: "编辑功能"
  },
  getCustomFunList: {
    url: "/tacos-cloud-console/v1/function/custom/page",
    method: "post",
    desc: "自定义功能分页查询"
  },
  getStandardFunList: {
    url: "/tacos-cloud-console/v1/function/standard/page",
    method: "post",
    desc: "标准功能及最新版本分页查询"
  },
  deleteFun: {
    url: "/tacos-cloud-console/v1/function/removeById",
    method: "delete",
    desc: "删除功能"
  },
  releasedFun: {
    url: "/tacos-cloud-console/v1/function/ver/released",
    method: "get",
    desc: "发布功能"
  },
  getStandardReferencedProduct: {
    url: "/tacos-cloud-console/v1/function/standard/pageReferencedProduct",
    method: "post",
    desc: "查询引用该版本功能的标准产品列表"
  },
  getCustomReferencedProduct: {
    url: "/tacos-cloud-console/v1/function/custom/pageReferencedProduct",
    method: "post",
    desc: "查询引用该功能的自定义产品列表"
  },
  getStandardMembersByVerId: {
    url: "/tacos-cloud-console/v1/function/standard/ver/getMembersByVerId",
    method: "get",
    desc: "标准功能元件列表查询"
  },
  getCustomMembersByVerId: {
    url: "/tacos-cloud-console/v1/function/custom/getMembersByFunctionId",
    method: "get",
    desc: "自定义功能元件列表查询"
  },
  getFunctionList: {
    url: "/tacos-cloud-console/v1/function/list",
    method: "post",
    desc: "根据identifier、name查询功能列表"
  },
  getFunctionVerList: {
    url: "/tacos-cloud-console/v1/function/standard/ver/list",
    method: "post",
    desc: "标准功能版本列表查询"
  },
  getFunctionHistoryListById: {
    url: "/tacos-cloud-console/v1/function/standard/ver/listByFunctionId",
    method: "get",
    desc: "根据功能id查询标准功能历史版本列表"
  },
  revokeReleased: {
    url: "/tacos-cloud-console/v1/function/revoke-released",
    method: "put",
    desc: "功能版本撤销发布"
  },

  releasedProd: {
    url: "/tacos-cloud-console/v1/product/released",
    method: "put",
    desc: "发布产品版本"
  },
  deleteProd: {
    url: "/tacos-cloud-console/v1/product/remove",
    method: "delete",
    desc: "删除产品"
  },
  queryModelJson: {
    url: "/tacos-cloud-console/v1/product/queryModelJson",
    method: "post",
    desc: "查看功能物模型"
  },
  changeProductInfo: {
    url: "/tacos-cloud-console/v1/product/baseUpdate",
    method: "put",
    desc: "产品信息变更"
  },
  getProductHistoryList: {
    url: "/tacos-cloud-console/v1/product/standard/historyVer",
    method: "get",
    desc: "查询产品历史版本"
  },
  // 规则校验
  memberIdentifierCheck: {
    url: "/tacos-cloud-console/v1/common/validityIdentifier",
    method: "put",
    desc: "校验属性指令事件的标识符是否唯一"
  },
  memberNameCheck: {
    url: "/tacos-cloud-console/v1/common/validityName",
    method: "put",
    desc: "校验属性指令事件的名称是否唯一"
  },
  funcIdentifierCheck: {
    url: "/tacos-cloud-console/v1/function/checkIdentifierUnique",
    method: "post",
    desc: "校验功能的标识符是否唯一"
  },
  funcNameCheck: {
    url: "/tacos-cloud-console/v1/function/checkNameUnique",
    method: "post",
    desc: "校验功能的名称是否唯一"
  }
};
